import { useSyncExternalStore } from 'react';

/**
 * Цвета токенов (index.css) как строки — для библиотек, которым нужен цвет, а не класс
 * (recharts: fill/stroke). Перечитываются при смене темы (MutationObserver на <html>).
 */
const NAMES = ['text', 'text-2', 'text-3', 'accent', 'border', 'border-soft', 'surface', 'muted', 'pos', 'neg', 'warn'] as const;
export type TokenName = (typeof NAMES)[number];
export type TokenColors = Record<TokenName, string>;

const FALLBACK: TokenColors = {
  text: '#1a1a1a',
  'text-2': '#66645f',
  'text-3': '#85837d',
  accent: '#ffd43b',
  border: '#e4e2dc',
  'border-soft': '#eeece7',
  surface: '#ffffff',
  muted: '#eeede8',
  pos: '#1b7f46',
  neg: '#c42b21',
  warn: '#b85a00',
};

function read(): TokenColors {
  if (typeof window === 'undefined') return FALLBACK;
  const style = getComputedStyle(document.documentElement);
  const out = { ...FALLBACK };
  for (const n of NAMES) {
    const v = style.getPropertyValue(`--${n}`).trim();
    if (v) out[n] = v;
  }
  return out;
}

// Снимок кешируется по className <html>: useSyncExternalStore требует стабильную ссылку.
let cache: { key: string; colors: TokenColors } | null = null;
function getSnapshot(): TokenColors {
  const key = document.documentElement.className;
  if (!cache || cache.key !== key) cache = { key, colors: read() };
  return cache.colors;
}

function subscribe(onChange: () => void) {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
}

/** Цвета токенов текущей темы; обновляются при смене класса .dark на <html>. */
export function useTokenColors(): TokenColors {
  return useSyncExternalStore(subscribe, getSnapshot, () => FALLBACK);
}
